export default __webpack_public_path__ + "static/media/opened-chest.09ae8ad6.png";